export default function checkDirectLogin({ next, store }) {
  const { isDirectLoginExist } = store.getters

  // Если у пользователя выбран AdWords-профиль
  if (isDirectLoginExist) {
    next()
    return
  }

  next({ name: 'select-account' })
}
